import React from "react";
import { IconType } from "react-icons";

import styles from "./GlobalNotificationBanner.module.css";

export interface GlobalNotificationBannerProps {
  icon: IconType;
  color: string;
  children?: React.ReactNode;
}

function GlobalNotificationBanner(props: GlobalNotificationBannerProps): JSX.Element {
  return (
    <div className={styles.root}>
      {props.icon({ size: 24, color: props.color, className: styles.icon })}
      <div style={{ color: props.color }}>{props.children}</div>
    </div>
  );
}

export default GlobalNotificationBanner;
